import { X } from 'lucide-react';
import type { ChipProps } from './Chip.types';
import './Chip.scss';

export default function Chip({
  variant = 'neutral', iconLeft, onRemove, removeLabel = 'Удалить', className, children, ...rest
}: ChipProps) {
  return (
    <span
      className={['chip', `chip--${variant}`, className || ''].filter(Boolean).join(' ')}
      {...rest}
    >
      {iconLeft ? <span className="chip__icon" aria-hidden="true">{iconLeft}</span> : null}
      <span className="chip__label">{children}</span>
      {onRemove ? (
        <button type="button" aria-label={removeLabel} className="chip__remove" onClick={onRemove}>
          <X size={12} />
        </button>
      ) : null}
    </span>
  );
}
